import styled, { css } from 'styled-components';
import { Button, Row } from '@workramp/ui';

export const ButtonsContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const ButtonRow = styled(Row)<{ isMobile: boolean; width?: string }>`
  gap: ${({ theme }) => theme.spacing(2)}px;
  ${({ isMobile }) => isMobile && `flex: 1;`}
  ${({ width }) => width && `width: ${width};`}
`;

export const ScaleButton = styled(Button)<{ $isSelected: boolean }>`
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      &:disabled {
        color: ${({ theme }) => theme.colors.on[0]};
        background-color: ${({ theme }) => theme.colors.primary[400]};
      }
    `}}
`;

export const Labels = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${({ isMobile }) =>
    isMobile &&
    css`
      margin-bottom: 8px;
    `}
`;
